/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Tile_Ebrana_HintInputs */

const cs_import_tile_ebrana_hint = /** @type {(inputs: Import_Tile_Ebrana_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makléři a nabídky z exportu eBrány (REALBrána). Opakovatelné, s náhledem změn.`)
};

const en_import_tile_ebrana_hint = /** @type {(inputs: Import_Tile_Ebrana_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brokers and offers from the eBrána (REALBrána) export. Re-runnable, with a change preview.`)
};

/**
* | output |
* | --- |
* | "Brokers and offers from the eBrána (REALBrána) export. Re-runnable, with a change preview." |
*
* @param {Import_Tile_Ebrana_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_tile_ebrana_hint = /** @type {((inputs?: Import_Tile_Ebrana_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Tile_Ebrana_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_tile_ebrana_hint(inputs)
	return cs_import_tile_ebrana_hint(inputs)
});